<form class="qualification-tab-form" [formGroup]="AddressTab">
    <!-- <div fxLayout="row" fxLayoutGap="50px">
        <mat-form-field class="county-width">
            <mat-label>County</mat-label>
            <mat-select formControlName="country">
                <mat-option *ngFor="let rl of CountryTypes" [value]="rl.name">
                    {{rl.name}}
                  </mat-option>
            </mat-select>
        </mat-form-field>
    </div> -->
    <div fxLayout="row" fxLayoutGap="50px">
        <mat-form-field class="address-width">
            <mat-label class="boldlabel">Address 1</mat-label>
            <input matInput placeholder="Address 1" formControlName="address1" value="">
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
        <mat-form-field class="address-width">
            <mat-label>Address 2</mat-label>
            <input matInput placeholder="Address 2" formControlName="address2"  value="">
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
        <mat-form-field class="address-width">
            <mat-label>Attention</mat-label>
            <input matInput placeholder="Attention"  formControlName="address3" value="">
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
        <mat-form-field class="city-width">
            <mat-label class="boldlabel">City</mat-label>
            <input matInput placeholder="City" formControlName="city" value="">
        </mat-form-field>
        <mat-form-field class="state-width">
            <mat-label class="boldlabel">State</mat-label>
            <mat-select formControlName="stateId" >
                <mat-option *ngFor="let rl of StateTypes" [value]="rl.id">
                    {{rl?.name}}
                  </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="50px">
        <mat-form-field class="zip-width">
            <mat-label class="boldlabel">Zip</mat-label>
            <input matInput placeholder="Zip" mask="00000||00000-0000" formControlName="zipCode" value="">
        </mat-form-field>
        <mat-checkbox  *ngIf="!IsMailingAddressTab" mat-input class="mailingAddress" formControlName="useAsMailingAddress" >Use as Mailing Address</mat-checkbox>
    </div>
</form>